import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SolucoesComponent } from './solucoes.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

@NgModule({
  declarations: [
    SolucoesComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    RouterModule,
    LocalizeRouterModule
  ],
  exports: [
    SolucoesComponent
  ]
})

export class SolucoesModule { }
